import React from 'react';
import './SessionWarningModal.css';

function SessionWarningModal({ show, onClose, onLogout }) {
  if (!show) return null;

  return (
    <div className="session-warning-overlay">
      <div className="session-warning-modal">
        <div className="session-warning-header">
          <h2>⚠️ Upozornenie na uplynutie session</h2>
        </div>
        <div className="session-warning-body">
          <p>Vaša session vyprší o <strong>5 minút</strong>.</p>
          <p>Je potrebné sa znovu prihlásiť pre pokračovanie práce.</p>
        </div>
        <div className="session-warning-footer">
          <button className="btn-primary" onClick={onLogout}>
            Prihlásiť sa znovu
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Pokračovať
          </button>
        </div>
      </div>
    </div>
  );
}

export default SessionWarningModal;
